export default (date: Date): string =>
	`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
